<template>
    <div class="strength">
        <div class="header">五大硬核实力乘风破浪</div>
        <div class="main">
            <div class="main-top">
                <div class="main-item" v-on:mouseenter="enter(1)" v-on:mouseleave="leave(1)">
                    <img src="../../../assets/images/service/strength/icon_zz_yel.png" alt="">
                    <span>种植基地</span>
                    <transition name = "fade">
                        <div class="handleDialog" v-show="show1">
                            <img src="../../../assets/images/service/strength/icon_zz_whi.png" alt="">
                            <div class="title">种植基地</div>
                            <div class="dec">得天独厚的自然环境打造中国最好的藏药种植基地</div>
                            <div class="line"></div>
                        </div>
                    </transition>
                </div>
                <div class="main-item" v-on:mouseenter="enter(2)" v-on:mouseleave="leave(2)">
                    <img src="../../../assets/images/service/strength/icon_yp_yel.png" alt="">
                    <span>饮片厂</span>
                    <transition name = "fade">
                        <div class="handleDialog" v-show="show2">
                            <img src="../../../assets/images/service/strength/icon_yp_whi.png" alt="">
                            <div class="title">饮片厂</div>
                            <div class="dec">集种植、采集、加工为一体的饮片厂确保品质管控</div>
                            <div class="line"></div>
                        </div>
                    </transition>
                </div>
                <div class="main-item" v-on:mouseenter="enter(3)" v-on:mouseleave="leave(3)">
                    <img src="../../../assets/images/service/strength/icon_zj_yel.png" alt="">
                    <span>制剂中心</span>
                    <transition name = "fade">
                        <div class="handleDialog dialog" v-show="show3">
                            <img src="../../../assets/images/service/strength/icon_zj_whi.png" alt="">
                            <div class="title">制剂中心</div>
                            <div class="dec">整合多个研发团队资源，第一个获得GMP认证的非民族地区的民族医药制剂中心</div>
                            <div class="line"></div>
                        </div>
                    </transition>
                </div>
            </div>
            <div class="main-bottom">
                <div class="bottom-item" v-on:mouseenter="enter(4)" v-on:mouseleave="leave(4)">
                    <img src="../../../assets/images/service/strength/icon_mx_yel.png" alt="">
                    <span>明星医生团队</span>
                    <transition name = "fade">
                        <div class="handleDialog dialog" v-show="show4">
                            <img src="../../../assets/images/service/strength/icon_mx_whi.png" alt="">
                            <div class="title">明星医生团队</div>
                            <div class="dec">汇集国内一流学科专家打造明星医生团队</div>
                            <div class="line"></div>
                        </div>
                    </transition>
                </div>
                <div class="bottom-item" v-on:mouseenter="enter(5)" v-on:mouseleave="leave(5)">
                    <img src="../../../assets/images/service/strength/icon_fw_yel.png" alt="">
                    <span>服务平台</span>
                    <transition name = "fade">
                        <div class="handleDialog dialog" v-show="show5">
                            <img src="../../../assets/images/service/strength/icon_fw_whi.png" alt="">
                            <div class="title">服务平台</div>
                            <div class="dec">集疗效管理、健康管理于一体的线上诊疗服务平台</div>
                            <div class="line"></div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                show1: false,
                show2: false,
                show3: false,
                show4: false,
                show5: false
            }
        },
        methods: {
            enter(num){
                if(num == 1){
                    this.show1 = true
                }else if(num == 2){
                    this.show2 = true
                }else if(num == 3){
                    this.show3 = true
                }else if(num == 4){
                    this.show4 = true
                }else if(num == 5){
                    this.show5 = true
                }
            },
            leave(num) {
                if(num == 1){
                    this.show1 = false
                }else if(num == 2){
                    this.show2 = false
                }else if(num == 3){
                    this.show3 = false
                }else if(num == 4){
                    this.show4 = false
                }else if(num == 5){
                    this.show5 = false
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    .strength {
        line-height: 1;
        .header {
            width: 100%;
            height: 189px;
            background-color: rgba(51,54,141,0.1);
            color: #33368D;
            text-align: center;
            line-height: 189px;
            font-size: 38px;
            font-weight: bold;
        }
        .main {
            padding: 67px 360px;
            background: #fff;
            .main-top {
                display: flex;
                border-bottom: 1px solid #eee;
                .main-item {
                    width: 400px;
                    height: 470px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    position: relative;
                    overflow: hidden;
                    img {
                        width: 48px;
                        height: 42px;
                    }
                    span {
                        margin-top: 33px;
                        color: #28307C;
                        font-size: 24px;
                    }
                    .handleDialog {
                        position: absolute;
                        width: 400px;
                        height: 470px;
                        top: 0px;
                        left: 0;
                        background: #28307C;
                        color: #fff;
                        padding: 0 38px;
                        box-sizing: border-box;
                        display: flex;
                        flex-direction: column;
                        // justify-content: center;
                        align-items: center;
                        img {
                            margin-top: 90px;
                            width: 74px;
                            height: 71px;
                        }
                        .title {
                            font-size: 28px;
                            font-weight: bold;
                            margin-top: 38px;
                        }
                        .dec {
                            width: 100%;
                            font-size: 18px;
                            line-height: 36px;
                            text-align: center;
                            margin-top: 40px;
                        }
                        .line {
                            width: 65px;
                            height: 6px;
                            background: #E0B747;
                            margin-top: 80px;
                        }
                    }
                    .dialog {
                        padding: 0 17px;
                    }
                }
                .main-item:not(:last-child){
                    border-right: 1px solid #EEEEEE;
                }
            }
            .main-bottom {
                 display: flex;
                .bottom-item {
                    width: 600px;
                    height: 470px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    position: relative;
                    img {
                        width: 48px;
                        height: 42px;
                    }
                    span {
                        margin-top: 33px;
                        color: #28307C;
                        font-size: 24px;
                    }
                    .handleDialog {
                        position: absolute;
                        width: 600px;
                        height: 470px;
                        top: 0px;
                        left: 0;
                        background: #28307C;
                        color: #fff;
                        padding: 0 38px;
                        box-sizing: border-box;
                        display: flex;
                        flex-direction: column;
                        // justify-content: center;
                        align-items: center;
                        img {
                            margin-top: 90px;
                            width: 74px;
                            height: 71px;
                        }
                        .title {
                            font-size: 28px;
                            font-weight: bold;
                            margin-top: 38px;
                        }
                        .dec {
                            width: 100%;
                            font-size: 18px;
                            line-height: 36px;
                            text-align: center;
                            margin-top: 40px;
                        }
                        .line {
                            width: 65px;
                            height: 6px;
                            background: #E0B747;
                            margin-top: 80px;
                        }
                    }
                }
                .bottom-item:not(:last-child) {
                    border-right: 1px solid #EEEEEE;
                }
            }
        }
    }
</style>
<style scoped>

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
        opacity: 0
    }
</style>